import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "overlay"]

  connect() {
    this.boundUpdateLayout = this.updateLayout.bind(this)
    this.boundHandleKeydown = this.handleKeydown.bind(this)

    this.updateLayout()
    window.addEventListener("resize", this.boundUpdateLayout)
    document.addEventListener("keydown", this.boundHandleKeydown)
  }

  disconnect() {
    window.removeEventListener("resize", this.boundUpdateLayout)
    document.removeEventListener("keydown", this.boundHandleKeydown)
  }

  toggle(event) {
    event?.preventDefault()

    if (this.isDesktop()) {
      return
    }

    this.isOpen() ? this.close() : this.open()
  }

  open(persist = true) {
    this.sidebarTarget.classList.remove("-translate-x-full")
    this.sidebarTarget.classList.add("translate-x-0")

    if (!this.isDesktop() && this.hasOverlayTarget) {
      this.overlayTarget.classList.remove("hidden")
    }

    if (persist) {
      localStorage.setItem("sidebarOpen", "true")
    }
  }

  close(persist = true) {
    this.sidebarTarget.classList.remove("translate-x-0")
    this.sidebarTarget.classList.add("-translate-x-full")

    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.add("hidden")
    }

    if (persist) {
      localStorage.setItem("sidebarOpen", "false")
    }
  }

  updateLayout() {
    if (this.isDesktop()) {
      this.open(false)
      if (this.hasOverlayTarget) {
        this.overlayTarget.classList.add("hidden")
      }
    } else {
      const storedPreference = localStorage.getItem("sidebarOpen")
      const shouldOpen = storedPreference === null ? true : storedPreference === "true"

      if (shouldOpen) {
        this.open(false)
      } else {
        this.close(false)
      }
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape" && !this.isDesktop()) {
      this.close()
    }
  }

  isDesktop() {
    return window.innerWidth >= 1024
  }

  isOpen() {
    return !this.sidebarTarget.classList.contains("-translate-x-full")
  }
}

